import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { Observable } from 'rxjs';
import { PaymentMethodInfo } from './model/payment-method-info';

@Injectable({
  providedIn: 'root'
})
export class PaymentInformationService {
  constructor(private http: HttpClient) {}

  fetchPaymentMethods(): Observable<PaymentMethodInfo[]> {
    return this.http.get<PaymentMethodInfo[]>(PLATFORM_ENVIRONMENT.apiUrl + '/paymentInfo');
  }
}
